export default () => {
	let slider

	return {
		modules: [],
		config: {
			slidesPerView: 1,
			spaceBetween: 20,
		},

		setupData() {
			this.modules = this.$root?.dataset?.modules?.split(',') || []
			this.config = Object.assign({}, this.config, JSON.parse(this.$root?.dataset?.config || '{}'))
		},

		async init() {
			this.setupData()
			const $refs = this.$refs

			if (!$refs.container) {
				return
			}
			const Swiper = (await import('swiper')).default

			if (this.modules.includes('Navigation')) {
				const bundle = await import('swiper/bundle')
				Swiper.use(bundle.Navigation)
			}

			slider = new Swiper($refs.container, this.config)
			$refs.container.classList.add('!overflow-visible')

			$refs.container.querySelector('.swiper-wrapper').style.display = 'block'
			Alpine.nextTick(() => $refs.container.querySelector('.swiper-wrapper').style.display = '')
		},
	}
}
